export default from './ChatListPage';



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/MobileMessages/components/ChatListPage/index.js